import React from 'react';

import { useFeedbackStore } from '@store';
import { Loaders } from '@types';

export const useLoader = (loaderName: Loaders) => {
	const hideLoader = useFeedbackStore((state) => state.hideLoader);
	const showLoader = useFeedbackStore((state) => state.showLoader);

	const hide = React.useCallback(() => {
		hideLoader(loaderName);
	}, [hideLoader, loaderName]);

	const show = React.useCallback(() => {
		showLoader(loaderName);
	}, [loaderName, showLoader]);

	return {
		hide,
		show,
	};
};

export const useIsVisibleLoader = (loaderName: Loaders) => {
	const visibleLoaders = useFeedbackStore((state) => state.visibleLoaders);

	return (visibleLoaders?.[loaderName] || 0) > 0;
};
